<template>
	<div class="micro-container">
		<Logo />
		<Sidebar />
		<div class="seach-wrapper">
			<van-search
				v-model="value"
				shape="round"
				background="linear-gradient(to right,#143BD9,#5172F8)"
				placeholder="请输入作品名称"
				@search="onSearch"
			/>
			<div class="tab-dropdown">
				<van-dropdown-menu active-color="#333333">
					<van-dropdown-item title="课程模块" v-model="courseModule" :options="courseOption" @change="changeModule"/>
					<van-dropdown-item title="推荐省份" v-model="recomProvince" :options="recomOption" @change="changeProvince" />
				</van-dropdown-menu>
			</div>
		</div>
		<section class="micro-list">
			<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :offset="35">
				<div class="item-wrapper" v-for="(item,index) in videoList" :key="index">
					<div class="item-top" @click="playVideo(item.video_url)">
						<div class="item-cover">
							<img :src="item.cover">
						</div>
						<!-- <video oncontextmenu="return false" :src="item.video_url" :poster="item.video_url+'?x-oss-process=video/snapshot,t_50,f_jpg,w_702,h_392'"></video> -->
						<div class="video-play-box">
							<div class="video-play">
								<img src="../assets/images/btn_start.png" >
							</div>
						</div>
					</div>
					<div class="item-bottom">
						<p class="item-title">{{item.title}}</p>
						<div class="item-info">
							<div class="item-name">
								<!-- <p>NO.{{item.sort}} {{item.province}}</p> -->
								<p>{{item.realname}}</p>
							</div>
							<button class="item-btn" :class="item.module == 'SYB' ? 'green' : (item.module == '网络创业' ? 'blue' : 'lightblue')">{{item.module}}</button>
						</div>
					</div>
				</div>
			</van-list>
		</section>
		<div v-if="isShow">
			<van-overlay :show="isShow">
				<div class="video-close" @click="closeVideo">
					<img src="../assets/images/close.ss.png">
				</div>
				<div class="video-box">
					<video oncontextmenu="return false" width="100%" height="100%" ref="videoPlayer" :src="videoSrc" controls controlslist="nodownload" disablePictureInPicture :poster="videoSrc+'?x-oss-process=video/snapshot,t_50,f_jpg,w_400,h_350'"></video>
				</div>
			</van-overlay>
		</div>
  </div>
</template>

<script>
import { getList, getModule, getProvince } from "../api/index"
import Logo from "../components/Logo";
import Sidebar from "../components/Sidebar";

import { Toast } from 'vant'
export default {
	name: "microLecture",
	components: {
		Logo,
		Sidebar
	},
	data() {
		return {
			isShow: false,
			videoSrc: '',
			value: '',
			courseModule: '',
			recomProvince: '',
			courseOption: [{
				text: '全部',
				value: ''
			}],
			recomOption: [{
				text: '全部',
				value: ''
			}],
			list: [],
			loading: false,
			finished: false,
			page: 1,
			videoList: []
		};
	},
	created() {
		this.getModule()
		this.getProvince()
	},
	methods:{
		getModule(){
			getModule().then(res=>{
				if(res.code == 200){
					let dataList = res.data.list
					dataList.forEach(item => {
						this.courseOption.push({
							text: item.name,
							value: item.key
						})
					});
				}
			}).catch({})
		},
		getProvince() {
			getProvince().then(res=>{
				if(res.code == 200){
					let dataList = res.data.list
					dataList.forEach(item => {
						this.recomOption.push({
							text: item.name,
							value: item.code
						})
					});
				}
			}).catch({})
		},
		onLoad() {
			let params = {
				course_title: this.value,
				curriculum_module: this.courseModule,
				province_code: this.recomProvince,
				page: this.page
			}
			getList(params).then(res=>{
				if(res.code == 200){
					this.page++
					this.videoList = this.videoList.concat(res.data.list)
					if(res.data.list.length == 0){
						this.finished = true
					}
				}
				this.loading = false
			}).catch(()=>{
				this.loading = false
			})
		},
		onSearch() {
			this.page = 1
			this.videoList = []
			this.finished = false
			this.getList()
		},
		changeModule(value) {
			this.courseModule = value
			this.onSearch()
		},
		changeProvince(value) {
			this.recomProvince = value
			this.onSearch()
		},
		getList(){
			let params = {
				course_title: this.value,
				curriculum_module: this.courseModule,
				province_code: this.recomProvince,
				page: this.page
			}
			getList(params).then(res=>{
				if(res.code == 200){
					this.page++
					this.videoList = res.data.list
					if(res.data.list.length == 0){
						Toast('未查询到相关数据');
					}
				}
			}).catch(()=>{})
		},
		playVideo(url) {
			this.videoSrc = url
			this.isShow = true
		},
		closeVideo() {
			this.isShow = false
			this.$refs.videoPlayer.pause();
		},
	}
};
</script>

<style lang="scss">
html{
	min-height: 100%;
	background-color: #F4F6FD;
}
	.micro-container{
		.van-overlay{
			background-color: rgba(0,0,0,1);
		}
		.mask{
			width: 100%;
			height: 100%;
			background: rgba($color: #000000, $alpha: 0.6);
			position: fixed;
			left: 0;
			top: 0;
		}
		.van-search .van-cell {
			// margin-left: 50%;
			// transform: translate(-50%);
			.van-icon{
				&::before{
					color: #ACB0BF;
				}
			}
		}
		.seach-wrapper{
			width: 100%;
			box-sizing: border-box;
			background: linear-gradient(to right, rgb(20, 59, 217), rgb(81, 114, 248));
			.tab-dropdown{
				.van-dropdown-menu__bar{
					position: relative;
					border-radius: 24px 24px 0px 0px;
					height: initial;
					padding: 20px 0;
					&::before{
						content: "";
						position: absolute;
						width: 2px;
						height: 30px;
						background-color: #9B9B9B;
						top: 0;
						left: 0;
						right: 0;
						bottom: 0;
						margin: auto;
					}
				}
				.van-dropdown-menu__title{
					color: #666;
					font-size: 28px;
					line-height: 36px;
					&::after{
						border-color: transparent transparent #666 #666;;
					}
				}
				.van-popup{
					padding: 24px 12px 0;
					width: auto;
					right: 0;
				}
				.van-dropdown-item__option--active{
					.van-cell__title{
						background: #E7F1FF!important;
						color: #1677FF!important;
					}
				}
				.van-cell--clickable{
					&:active{
						background-color: initial;
					}
				}
				.van-cell{
					display: inline-block;
					vertical-align: top;
					width: 50%;
					padding: 0 12px;
					margin-bottom: 24px;
					.van-cell__title{
						border-radius: 8px;
						background: #F5F5F5;
						padding: 15px 0;
						line-height: 42px;
						font-size: 30px;
						color: #333;
						text-align: center;
					}
					.van-cell__value{
						position: absolute;
						width: 36px;
						height: 36px;
						right: 12px;
						bottom: 0;
						background-image: url(../assets/images/xuanzhong.png);
						background-size: 100%;
						.van-icon{
							display: none;
						}
					}
					&::after{
						content: "";
						display: none;
					}
				}
			}
			.tab-wrapper{
				width: 100%;
				background: #FFFFFF;
				border-radius: 24px 24px 0px 0px;
				line-height: 86px;
				font-size: 28px;
				font-weight: 500;
				color: #333333;
				position: relative;
				.item{
					float: left;
					width: 50%;
					text-align: center;
					position: relative;
					.van-cell{
						padding: 12px 16px;
					}
					.van-cell__value--alone{
						text-align: center;
					}
					.course{
						display: inline-block;
						vertical-align: middle;
					}
					.tab-icon{
						position: absolute;
						top: 50%;
						left: 75%;
						transform: translate(-50%, -50%);
					}
				}
				.grey{
					font-size: 28px;
					font-weight: 400;
					color: #666666;
				}
				.black{
					font-size: 28px;
					font-weight: 500;
					color: #333333;
				}
				.tab-border{
					width: 2px;
					height: 30px;
					background: #9B9B9B;
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					z-index: 1;
				}
				.popup{
					width: 100%;
					height: 1000px;
					position: relative;
					bottom: -86px;
					padding-top: 18px;
					.van-overlay, .van-popup{
						position: absolute;
					}
					ul{
						padding: 0 12px;
						li{
							float: left;
							width: 50%;
							height: 72px;
							margin-top: 24px;
							span{
								display: inline-block;
								width: 339px;
								height: 72px;
								background: #F5F5F5;
								margin: 0 12px;
								border-radius: 8px;
								text-align: center;
								line-height: 72px;
								font-size: 30px;
								font-weight: 400;
								color: #333333;
								position: relative;
								.train{
									position: absolute;
									bottom: 0;
									right: 0;
									border-color: transparent #1677FF; /*上下颜色 左右颜色*/
									border-width: 35px 44px 0px 0;
									border-style: solid;
									
								}
								.train-img{
									width: 38px;
									height: 35px;
									position: absolute;
									bottom: 10px;
									right: 0;
									z-index: 7;
								}
							}
							.active{
								color: #1677FF;
								background: #E7F1FF;
							}
						}
					}
					
				}
			}
		}
		.micro-list{
			// padding-bottom: 40px;
			// background-color: #F4F6FD;
			.item-wrapper{
				padding: 32px 24px 0;
				.item-top{
					position: relative;
					width: 100%;
					height: 392px;
					background-color: #000;
					overflow: hidden;
					video{
						width: 100%;
						height: 100%;
					}
					.item-cover{
						width: 100%;
						height: 100%;
						img{
							width: 100%;
							height: 100%;
						}
					}
					.video-play-box{
						position: absolute;
						left: 0;
						right: 0;
						top: 0;
						bottom: 0;
						margin: auto;
						.video-play{
							position: absolute;
							width: 110px;
							height: 110px;
							left: 0;
							right: 0;
							top: 0;
							bottom: 0;
							margin: auto;
							img{
								display: block;
								width: 100%;
								height: 100%;
							}
						}
					}
				}
				
				.item-bottom{
					background: #fff;
					padding: 36px 32px 32px;
					box-shadow: 0px 2px 16px 0px rgba(219,224,235,0.64);
					.item-title{
						font-size: 34px;
						font-weight: 500;
						color: #333333;
						margin-bottom: 12px;
						line-height: 48px;
						max-height: 96px;
						display:-webkit-box;
						overflow:hidden;
						text-overflow:ellipsis;
						-webkit-line-clamp:2;
						-webkit-box-orient:vertical;
					}
					.item-info{
						display: flex;
						align-items: center;
						.item-name{
							flex: 1;
							font-size: 28px;
							font-weight: 400;
							color: #999999;
							line-height: 42px;
							padding: 7px 0;
						}
						.item-btn{
							font-size: 24px;
							font-weight: 400;
							border: none;
							line-height: 56px;
							text-align: center;
							padding: 0 26px;
						}
						.blue{
							background: #EAEDFD;
							color: #2F54EB;
						}
						.green{
							background: #E5F7DF;
							color: #54953D;
						}
						.lightblue{
							background: #CEEFFC;
							color: #02ADEF;
						}
					}
				}
			}
		}
			
	}
	.video-close{
    position: absolute;
    width: 84px;
    height: 84px;
    right: 0;
    top: 0;
    margin: auto;
    img{
			display: block;
			width: 48px;
			height: 48px;
			margin-top: 18px;
			margin-left: 18px;
    }
	}
	.video-box{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 84px;
    margin: auto;
	}
</style>
